// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function inspectArg(arg: any): any {
  return arg;
}
